<template>
  <div id="app">
    <Loader v-if="$store.state.formSubmitLoading" />
    <nav class="navbar navbar-light bg-white mb-5">
      <div class="container ">
        <a
          class="container justify-content-center justify-content-md-between"
          href="#"
        >
          <!-- <img :src="'./assets/colonnade_logo.png'" alt="Colonnade logo" /> -->
          <img
            :src="'./assets/Colonnade-logo.png'"
            alt="Colonnade logo"
            style="max-width: 300px; height: auto;"
          />
        </a>
      </div>
      <div class="container justify-content-right justify-content-md-between">
        <a class="navbar-brand" href="#"> </a>
      </div>
    </nav>
    <!-- <div v-if="merchant_id === 'colo213'">
      <div class="alert alert-light text-center mb-4">
        <div class="h5 m-0" style="color: red;">
          A Colonnade Vezetői biztosítása csak értékesítőn keresztül köthető. Kérem, keresse fel
          biztosításközvetítőjét.
        </div>
      </div>
    </div>
    <div v-else class="container"> -->
    <div class="container">
      <div
        class="mb-3 ms-md-auto flex-grow-1 w-100 w-md-auto flex-md-grow-0 connection"
      >
        {{ datas.connection }}
        <div v-if="datas.product_code">
          {{ " Kalkuláció azonosítója:" + datas.product_code }}
        </div>
      </div>
      <NavigationTop />
      <div class="alert alert-light text-center mb-4">
        <p v-if="$store.state.page == 1" class="h5 m-0">
          <template v-if="isMFO && $store.state.marks.mfo_uzenet">
            <span v-html="$store.state.marks.mfo_uzenet"></span>
          </template>
          <template v-else>
            <div>
              Köszöntjük a Colonnade Biztosító Vezető Tisztségviselők
              Felelősségbiztosítása (D&O) tarifáló oldalán!
            </div>
          </template>
        </p>
        <p v-else-if="$store.state.page == 2" class="h5 m-0">
          Kérjük, tegye meg a nyilatkozatokat!
        </p>
        <p v-else-if="$store.state.page == 3" class="h5 m-0">
          Kérjük, ellenőrizze az alábbi összesítést, és győződjön meg a korábban
          megadott adatok helyességéről! Ha mindent rendben talált, az oldal
          alján található nyilatkozatok elfogadásával véglegesítheti a
          biztosítási szerződést.
        </p>
        <!-- <p v-else-if="$store.state.page == 4" class="h5 m-0">
          Kérjük, adja meg a biztosítani kívánt ingatlan és a szerződő adatait!
        </p>
        <p v-else-if="$store.state.page == 5" class="h5 m-0">
          Kérjük, ellenőrizze az alábbi összesítést, és győződjön meg a korábban megadott adatok
          helyességéről! Ha mindent rendben talált, az oldal alján található nyilatkozatok
          elfogadásával véglegesítheti a biztosítási szerződést.
        </p> -->
      </div>
      <request-pdf-buton :showFromPage="3"></request-pdf-buton>
      <save-link-button :showFromPage="3"></save-link-button>
      <h2 class="text-danger mb-2" v-if="$store.state.generalErrors.length > 0">
        Hibák
      </h2>
      <ul class="text-danger mb-5" v-if="$store.state.generalErrors.length > 0">
        <li
          v-for="(error, key) in $store.state.generalErrors"
          :key="`gerror-${key}`"
        >
          {{ error }}
        </li>
      </ul>
      <!-- <OverallData v-if="$store.state.page > 1 && $store.state.page < 5" /> -->
      <OverallDataMinimal
        v-if="$store.state.page > 1 && $store.state.page < 5"
      />
      <ValidationObserver v-slot="{ invalid, validate }">
        <form id="form">
          <FirstPage
            v-if="$store.state.page >= 1"
            v-show="$store.state.page === 1"
          />
          <!-- <SecondPage v-if="$store.state.page >= 2" v-show="$store.state.page === 2" /> -->
          <!-- <ThirdPage v-if="$store.state.page >= 2" v-show="$store.state.page === 2" /> -->
          <FourthPage
            v-if="$store.state.page >= 2"
            v-show="$store.state.page === 2"
          />
          <FifthPage
            v-if="$store.state.page >= 3"
            v-show="$store.state.page === 3"
          />
        </form>
        <Navigation v-bind:invalid="invalid" :validate="validate" />
        <p
          v-show="invalid"
          class="h6 mb-3 text-center text-md-end text-danger"
          id="invalid_inputs"
        >
          Kérjük, töltse ki a csillaggal (*) megjelölt mezőket.
        </p>
        <!-- <p v-if="$store.state.page === 3" class="text-justify">
          A fenti gomb megnyomásával kijelentem, hogy jelen ajánlatban részletezett feltételekkel
          ajánlatot teszek a Colonnade Édes Otthon Lakásbiztosítás szerződés megkötésére a Colonnade
          Insurance S.A. Magyarországi Fióktelepe részére. Kijelentem, hogy a jelen Biztosítási
          ajánlatban feltüntetett adatok a valóságnak megfelelnek, a valótlan adatok közlése pedig a
          biztosítási szerződés érvénytelenségét vonja maga után. A létrejött Biztosítási szerződés
          alapján a Biztosító díjfizetés ellenében arra vállal kötelezettséget, hogy a Colonnade
          Édes Otthon Lakásbiztosítás biztosítási feltételeiben meghatározott kockázatokra fedezetet
          nyújt és a biztosítási feltételekben meghatározott biztosítási esemény bekövetkezése
          esetén a vonatkozó biztosítási feltételekben meghatározott szolgáltatást nyújtja.
        </p> -->
      </ValidationObserver>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

import FirstPage from "./components/FirstPage";
import SecondPage from "./components/SecondPage";
import ThirdPage from "./components/ThirdPage";
import FourthPage from "./components/FourthPage";
import FifthPage from "./components/FifthPage";
import NavigationTop from "./NavigationTop";
import OverallData from "./OverallData";
import OverallDataMinimal from "./OverallDataMinimal";
import Navigation from "./Navigation";
import Footer from "./Footer";
import Loader from "./components/Loader";
import RequestPdfButton from "./components/components/RequestPdfButton";
import jQuery from "jquery";
import SaveLinkButton from "./components/components/SaveLinkButton.vue";
import RequestPdfButon from "./components/components/RequestPdfButton.vue";

import { debounce } from "debounce";

export default {
  components: {
    FirstPage,
    SecondPage,
    ThirdPage,
    FourthPage,
    FifthPage,
    Navigation,
    NavigationTop,
    Footer,
    OverallData,
    OverallDataMinimal,
    Loader,
    RequestPdfButton,
    SaveLinkButton,
    RequestPdfButon,
  },
  data() {
    return {
      isMFO: false,
    };
  },
  computed: {
    ...mapGetters({
      datas: "getAllState",
    }),
    ...mapFields(["merchant_id", "page", "email_valid_code", "last_email"]),
    ...mapFields({
      contractorLastName: "contractSettings.lastName",
      contractorEmail: "contractSettings.email",
      contractorEmailVerification: "contractSettings.emailVerification",
    }),
    emailVerificationDatas: function() {
      return {
        email: this.contractorEmail,
        emailVerification: this.contractorEmailVerification,
        validCode: this.email_valid_code,
        lastEmail: this.lastEmail,
        lastName: this.contractorLastName,
      };
    },
  },
  methods: {
    ...mapActions([
      "verifyPage",
      "getStoredData",
      "getMarks",
      "updateMarks",
      "getSelectLists",
    ]),
  },
  created() {
    localStorage.removeItem("storage_uid");
    localStorage.removeItem("last_interaction");

    this.getMarks();
    this.getSelectLists();

    const search_params = window.location.search.substring(1).split("&");
    search_params.forEach((param) => {
      const [key, value] = param.split("=");
      if (key == "merchant_id" && value) this.merchant_id = value;
      if (key == "fetch_uid" && value)
        this.$store.dispatch("getSavedDataByUid", value);
    });
    this.$gtm.trackEvent({
      event: null, // Event type [default = 'interaction'] (Optional)
      category: "Calculator",
      action: "click",
      label: "Home page SIP calculator",
      value: 5000,
      noninteraction: false, // Optional
    });
  },
  mounted() {
    jQuery(document).on("select2:open", () => {
      document.querySelector(".select2-search__field").focus();
    });
  },

  watch: {
    datas: {
      handler: debounce(function(after, before) {
        if (this.page !== 1 && this.page !== 3) return;
        if (this.$store.state.code === "generatelink")
          this.$store.commit("setClaimIdentifier", null);
        this.verifyPage();
      }, 3000),
      deep: true,
    },
    emailVerificationDatas: {
      handler: debounce(function(after, before) {
        if (this.page !== 4) return;

        if (
          this.contractorEmail &&
          this.contractorEmailVerification &&
          (!this.email_valid_code || this.last_email != this.contractorEmail) &&
          this.contractorLastName
        ) {
          const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
          if (
            !emailRegex.test(this.contractorEmail) &&
            !emailRegex.test(this.contractorEmailVerification)
          )
            return;

          if (this.contractorEmail === this.contractorEmailVerification) {
            this.verifyPage();
          }
        }
      }, 3000),
      deep: true,
    },
    page: {
      handler: debounce(function(newState, oldState) {
        if (newState > oldState) {
          this.updateMarks();
        }
      }, 1500),
    },
  },
};
</script>

<style lang="scss">
$red: #e4002b;

html {
  scroll-behavior: smooth;
}

body {
  color: #555 !important;
  font-size: 14px !important;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.form-check-input {
  width: 17px !important;
  height: 17px !important;
  margin-top: 0.125em !important;
  margin-right: 0.5em;
}

label,
.label {
  margin-bottom: 3px;
  font-size: 14px;

  &.col-sm-4 {
    font-weight: bold !important;
  }
}

span.info {
  text-align: center;
  display: inline-block;
  background-color: $red;
  border-radius: 50%;
  color: white;
  max-width: 21px;
  max-height: 21px;
  width: 21px;
  height: 21px;
  line-height: 21px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  font-weight: bold;
}

h1,
h2 {
  color: $red;
  text-transform: uppercase;
  font-weight: 600 !important;
  margin: 0 0 30px !important;
  line-height: 140%;
}

h1 {
  font-size: 20px !important;
}

h2,
.h2 {
  font-size: 17px !important;
}

.datepicker > button {
  background-color: $red !important;
  border-color: $red !important;

  &:hover,
  &:focus,
  &:active {
    background-color: $red !important;
    border-color: $red !important;
  }
}

.btn-red {
  background-color: $red !important;
  color: white !important;
  font-size: 14px !important;
  padding: 8px 10px !important;
}

.btn-outline-danger {
  color: $red !important;
  border-color: $red !important;
  font-size: 14px !important;
  padding: 8px 10px !important;

  &:hover,
  &:active,
  &:focus {
    background-color: $red !important;
    color: white !important;
  }
}

.alert-dark {
  background-color: #6c757d !important;
  color: white !important;
}

.alert-light {
  color: #555 !important;
}

.datepicker-prepend-input {
  flex-grow: 1;

  input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    flex-grow: 1;
  }
}

.swal2-close:focus {
  box-shadow: none;
}

.swal2-icon {
  color: #ced4da !important;
  border-color: #ced4da !important;
}

::selection {
  color: white;
  background: #333;
  text-shadow: none;
}
.connection {
  color: #797f838f;
}
.smalltext {
  font-size: 12px;
  font-style: italic;
}
.percentage {
  color: $red;
}
.img-nsu {
  height: auto;
  max-width: 40%;
  float: right;
}
</style>
